import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ScoreService {
    // eslint-disable-next-line
    constructor(http) {
        this.http = http;
    }
    getScoreRanges() {
        return this.http.get(environment.api.base + 'scores/ranges');
    }
    updateScore(data, scoreId) {
        return this.http.put(environment.api.base + 'scores/' + scoreId, data);
    }
}
ScoreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScoreService_Factory() { return new ScoreService(i0.ɵɵinject(i1.HttpClient)); }, token: ScoreService, providedIn: "root" });
